<template>
  <div class="success-body">
    <div class="card">
      <div class="success-block">
        <div class="right-mark">
          <i class="checkmark">✓</i>
        </div>
        <h1>Success</h1>
        <p>Thank You!</p>
        <div class="go-back-btn">
          <el-button @click="goBack">Go back to Supply Request Form</el-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
  },
};
</script>
<style lang="scss">
.success-body {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  .card {
    background: white;
    border-radius: 4px;
    box-shadow: 0 2px 3px #c8d0d8;
    display: inline-block;
    margin: 0 auto;
    .go-back-btn {
      text-align: center;
      margin-top: 15px;
      .el-button {
        font-weight: 600;
        background: linear-gradient(90deg, #00d1bb, #0061ec);
        color: #fff;
        border: none;
        border-radius: 30px;
      }
    }
    .success-block {
      padding: 20px 50px;
      .right-mark {
        border-radius: 200px;
        height: 200px;
        width: 200px;
        position: relative;
        background: #f8faf5;
        margin: 0 auto;
        margin-bottom: 15px;
        i {
          color: #9abc66;
          font-size: 100px;
          position: absolute;
          left: 25%;
          top: 10%;
        }
      }
      h1 {
        color: #88b04b;
        font-family: "Nunito Sans", "Helvetica Neue", sans-serif;
        font-weight: 900;
        font-size: 40px;
        margin-bottom: 10px;
        text-align: center;
      }
      p {
        color: #404f5e;
        font-family: "Nunito Sans", "Helvetica Neue", sans-serif;
        font-size: 20px;
        margin: 0;

        text-align: center;
      }
    }
  }
}
</style>
